import $ from 'jquery';

import {
    v
} from './viewport.js';

import eye from '../../assets/icons/eye.svg';
import eyeN from '../../assets/icons/eye-n.svg';
import circle from '../../assets/icons/camera_video.svg';
import house from '../../assets/icons/house.svg';

import expandWhite from '../../assets/icons/caret-right.svg';

export const createShowAll = () => {

    $('#c-navbar-top-left').append(getShowAllBoilerplate());

    $('#showAll').on('click', () => {
        v.objects.forEach(x => {
            showObject(x);
        });
        v.requestRenderIfNotRequested();
    });

}

export const createHideAll = () => {

    $('#c-navbar-top-left').append(getHideAllBoilerplate());

    $('#hideAll').on('click', () => {
        v.objects.forEach(x => {
            hideObject(x);
        });
        v.requestRenderIfNotRequested();
    });

}

export const createReset = () => {
    $('#c-navbar-top-left').append(getResetBoilerplate());

    $('#reset').on('click', () => {
        v.objects.forEach(x => {
            showObject(x);
        });
        v.createCameraTween({x: -10, y: 6, z: 10})
        v.requestRenderIfNotRequested();

        //hide camera selection
        $('.caret-camera').removeClass('caret-camera-active');
    });
}

const toggleObject = x => {
    v.isVisible(x) ? hideObject(x) : showObject(x);
    v.requestRenderIfNotRequested();
}

const showObject = x => {
    v.showObject(x);
    $(`#${x.uuid} button img`).attr("src", eye);
}

const hideObject = x => {
    v.hideObject(x);
    $(`#${x.uuid} button img`).attr("src", eyeN);
}

const getShowAllBoilerplate = () => {
    return `
    <button id="showAll" class="c-btn" title="Alle einblenden">
        <img src="${eye}" alt="eye">
    </button>
    `
}

const getHideAllBoilerplate = () => {
    return `
    <button id="hideAll" class="c-btn" title="Alles ausblenden">
        <img src="${eyeN}" alt="eye">
    </button>
    `
}

const getResetBoilerplate = () => {
    return `
    <button id="reset" class="c-btn" title="zurücksetzen">
        <img src="${house}" alt="reset">
    </button>
    `
}

export const createObject = (object, location = 'main') => {

    const name = object.name.slice(5).replace(/_/g, ' ');

    const icon = v.isVisible(object) ? eye : eyeN;

    $(`#${location}-elements`).append(getObjectBoilerplate(object.uuid, name, icon));

    $(`#${object.uuid}-toggle`).on('click', () => {
        toggleObject(object);
    });

    $(`#${object.uuid}`)
        .on('mouseenter', () => {
            v.showOutline(object);
            console.log(object.name)
            v.requestRenderIfNotRequested();
        })


}

export const createGroup = (id, name, objects, location) => {

    $(`#${location}-elements`).append(getGroupBoilerplate(id, name));

    $(`#${id}-expand`).on('click', () => {
        $(`#${id}-expand-img`).toggleClass('expand-img-active');
    });

    $(`#${id}-show`).on('click', () => {
        objects.forEach(x => {
            showObject(x);
            v.requestRenderIfNotRequested();
        })
    });

    $(`#${id}-hide`).on('click', () => {
        objects.forEach(x => {
            hideObject(x);
            v.requestRenderIfNotRequested();
        })
    });

    $(`#${id} > .caret`)
        .on('mouseenter', () => {
            v.showOutlines(objects);
            v.requestRenderIfNotRequested();
        })

}

export const createCamera = (c, pos) => {
    $(`#${pos}`).append(getCameraBoilerplate(c.id, c.name));

    $(`#${c.id}`).on('click', () => {
        $('.caret-camera').removeClass('caret-camera-active');
        $(`#${c.id}`).addClass('caret-camera-active');
        createHideCameraTween(c);
    })
}

export const createHideCameraTween = (c) => {
    v.createCameraTween(c.pos, c.tar);
    hideObjects(c.obj)
}

const hideObjects = (obj) => {
    v.objects.forEach(x => {
        if(obj.includes(x.name)) {
            showObject(x);
        } else {
            hideObject(x);
        }
    })
}

const getObjectBoilerplate = (uuid, name, icon) => {
    return `
        <div id="${uuid}" class="caret caret-object">
            <div class="caret-left">
                <div class="caret-name">
                    ${name}
                </div>
            </div>
            <div class="caret-right">
                <button id="${uuid}-toggle" class="c-btn" title="ein-/ausblenen">
                    <img src="${icon}" alt="eye">
                </button>
            </div>
        </div>
    `
}

const getGroupBoilerplate = (id, name) => {
    return `
        <div id="${id}" class="group">
            <div class="caret caret-group">
                <div class="caret-left">
                    <button id="${id}-expand" class="c-exp expand-btn" 
                    type="button" data-toggle="collapse" data-target="#${id}-elements" aria-expanded="false" aria-controls="collapseExample" title="erweitern/minimieren">
                        <img id="${id}-expand-img" class="expand-img" src="${expandWhite}" alt="eye">
                    </button>
                    <div class="caret-name caret-name-group">
                        ${name}
                    </div>
                </div>
                <div class="caret-right">
                    <button id="${id}-show" class="c-btn" title="einblenden">
                        <img src="${eye}" alt="eye">
                    </button>
                    <button id="${id}-hide" class="c-btn" title="ausblenden">
                        <img src="${eyeN}" alt="eye">
                    </button>
                </div>
            </div>
        <div class="elements collapse" id="${id}-elements"></div
    `
}

const getCameraBoilerplate = (id, name) => {
    return `
        <div id="${id}" class="caret caret-object caret-camera">
            <div class="caret-left">
                <div class="c-con">
                    <img src="${circle}" alt="logo">
                </div>
                <div class="caret-name">
                    ${name}
                </div>
            </div>
        </div>
    `
}